module.exports = __webpack_public_path__ + "static/media/Bulletin_Template_B.8d481e8b.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/components/CreateProductWizard/images/Bulletin_Template_B.JPG
// module id = 1075
// module chunks = 0